<template>
    <div class="container">
        <template v-if="loading">
            <div class="row">
                <div class="col-12 justify-content-center align-items-center">
                    <clip-loader :loading="loading" :size="'3em'" :color="'#729FCC'"/>
                </div>
            </div>
        </template>
        <template v-else-if="err">
            <p class="text-center">{{$t('REGISTRATION.USERS.serviceUnavailable')}}</p>
        </template>
        <transition-group name="slide-up" tag="div" class="row" v-else>
            <user-table-row :user.sync="user"
                            @addUserToShop="$emit('addUserToShop', $event)"
                            @changeTab="handleTabChange"
                            @userRemoved="init"
                            v-for="(user, index) in displayedUsers"
                            :level="0"
                            :key="user.id + index" />
        </transition-group>
    </div>
</template>

<script type="text/babel">
import Filters from '../../../../mixins/CphFilters.vue';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {RegistrationPerimeter} from '../../../../router/perimeters/registrationPerimeter';
import UserTableRow from './UserTableRow';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import {EventBus} from '@/eventbus';

export default {
    name: 'UserTable',
    components: {UserTableRow, ClipLoader},
    perimeters: [RegistrationPerimeter],
    data () {
        return {
            err: '',
            loading: true,
            users: [],
            allUsers: null,
            loggedInUser: null
        };
    },
    mixins: [Filters],
    computed: {
        ...mapGetters({
            user : 'getUser'
        }),
        displayedUsers () {
            if (this.user.role === this.$TYPES.ROLES.ADMIN) {
                return this.allUsers;
            } else {
                return [this.loggedInUser] || [];
            }
        }
    },
    methods: {
        ...mapMutations(['setUserTree']),
        ...mapActions([
            'confirmAction',
            'DelUser',
            'GetAllUsers',
            'buildDependentsTree',
            'GetUser'
        ]),
        handleTabChange (tabData) {
            this.$emit('changeTab', {name: 'Register', ...tabData});
        },
        addUser () {
            this.$emit('changeTab', {name: 'Register', data: null});
        },
        async init () {
            try {
                if(this.user.role === this.$TYPES.ROLES.ADMIN) {
                    this.allUsers = await this.GetAllUsers();
                } else {
                    this.loggedInUser = await this.buildDependentsTree(
                        await this.GetUser(this.user.id)
                    );
                }
            } catch (err)  {
                this.err = err;
            }
            this.loading = false;
        }
    },
    created () {
        if(!this.userData) {
            this.init();
        }
        EventBus.$on('updateUserList', () => this.init());
    }
};

</script>

